import React, { Component } from 'react';
import './styles.scss';

export default class Logo extends Component {
    render() {
        return (
            <a href="/"><img alt="Cubiqle" style={this.props.style} className='logo' src={process.env.PUBLIC_URL + '/img/logo.png'}/></a>
        )
    }
}